export default {
    _default: (field) => `${field} ist ungültig.`,
    _invalid_format: (field, {format}) => `The field must be in the format ${format}.`,
    _atLeastOneRule: (field) => ` TODO `,
    equals: (field) => `${field} TODO .`,
    after: (field, {target, inclusion, format}) => `${field} muss nach ${target} liegen.`,
    alphadash: (field) => `${field} darf alphanumerische Zeichen sowie Striche und Unterstriche enthalten.`,
    alphanumeric: (field) => `${field} darf nur alphanumerische Zeichen enthalten.`,
    alphaspaces: (field) => `The ${field} TODO .`,
    alpha: (field) => `${field} darf nur alphabetische Zeichen enthalten.`,
    before: (field, {target, inclusion, format}) => `${field} muss vor ${target} liegen.`,
    between: (field, {from, to}) => `${field} muss zwischen ${from} und ${to} liegen.`,
    dateBetween: (field, {min, max}) => `${field} muss zwischen ${min} und ${max} liegen.`,
    date: (field, {format}) => `${field} muss das Format ${format} haben.`,
    time: (field) => `${field} muss das Format HH:mm:ss haben.`,
    datetime: (field, {format}) => `${field} muss das Format ${format} haben.`,
    decimal: (field, {decimals = '*'} = {}) => `${field} muss numerisch sein und darf ${decimals === '*' ? '' : decimals} Dezimalpunkte enthalten.`,
    digits: (field, {length}) => `${field} muss numerisch sein und exakt ${length} Ziffern enthalten.`,
    email: (field) => `${field} muss eine gültige E-Mail-Adresse sein.`,
    in: (field) => `${field} muss ein gültiger Wert sein.`,
    integer: (field) => `The ${field} TODO .`,
    ip: (field) => `${field} muss eine gültige IP-Adresse sein.`,
    maxlength: (field, {length}) => `${field} darf nicht länger als ${length} Zeichen sein.`,
    minlength: (field, {length}) => `${field} muss mindestens ${length} Zeichen lang sein.`,
    max: (field, {max}) => `The ${field} TODO .`,
    min: (field, {min}) => `The ${field} TODO .`,
    numeric: (field) => `${field} darf nur numerische Zeichen enthalten.`,
    match: (field) => `Das Format von ${field} ist ungültig.`,
    required: (field) => `${field} ist ein Pflichtfeld.`,
    url: (field) => `${field} ist keine gültige URL.`
};
